<script>
    import dayjs from 'dayjs';
    import SingleCourse from './SingleCourse.svelte';

    export let range;

</script>
{#if range.length == 0}

    <div class='alert alert-secondary mb-3 mt-3 clearfix'>
        <h4 class='float-start me-3'>
            <span class='fas fa-info-circle'></span>
        </h4>
        There are zero courses to select.
    </div>

{:else}

    {#each range as r}

        <h3 class='mb-3'>
            <span class='fas fa-calendar'></span> { dayjs(r.date).format('dddd, DD MMMM YYYY')}
        </h3>

        <div class='list-group mb-3'>

            {#each r.courses as c}

                <div class='list-group-item'>

                    <SingleCourse
                        course={c}
                    />

                </div>

            {/each}            

        </div>

        <hr/>


    {/each}

    

{/if}